import React, { useEffect, useState } from 'react';
import { Text, ToggleButton, Pane, Label, CompositeTextInput, Flex } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { PuffLoader } from 'react-spinners';
import classnames from 'classnames';
import { Config } from '@leverege/plugin';
import S from './CustomerAccount.css';
import C from '../Constants';
import UserForm from '../components/UserForm';
import RecovrSales from '../../../util/RecovrSales';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CustomerAccount(props) {
  const {
    onChange,
    isNewCustomer,
    exAcctEmail,
    exAcct,
    newAcct,
    newAcctErrors,
    location,
    exAcctErrors
  } = props;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const onChangeNewAcct = ({
    data
  }) => {
    onChange({
      data: 'isNewCustomer',
      value: data
    });
  };
  const onChangeUserForm = ({
    data,
    value
  }) => {
    onChange({
      data: 'newAcct',
      value: {
        ...newAcct,
        [data]: value
      }
    });
  };
  const onChangeExAcct = ({
    data,
    value
  }) => {
    if (exAcct?.email) {
      onChange({
        data: 'exAcct',
        value: {
          ...exAcct,
          [data]: value
        }
      });
    }
  };
  function getCountryAndStateFromAddress(address) {
    if (!address) {
      return {};
    }
    const stateMatches = [];
    const countryMatches = [];

    // for each country
    for (let i = 0; i < C.COUNTRIES.length; i++) {
      const currentCountry = C.COUNTRIES[i];

      // for each state in the country
      for (let j = 0; j < currentCountry.states.length; j++) {
        const currentState = currentCountry.states[j];

        // if the address matches the state regex, save this state and country
        if (address.match(currentState.addressRegexPattern)) {
          stateMatches.push({
            country: currentCountry.name,
            countryRegex: currentCountry.addressRegexPattern,
            state: currentState.value,
            stateRegex: currentState.addressRegexPattern
          });
        }
      }

      // if the country regex matches, save this country
      if (address.match(currentCountry.addressRegexPattern)) {
        countryMatches.push({
          country: currentCountry.name,
          countryRegex: currentCountry.addressRegexPattern
        });
      }
    }

    // find the state match that is closest to the end of the string
    const bestStateMatch = stateMatches.reduce((best, match) => {
      const index = getLastIndexOfRegex(address, match.stateRegex);
      if (index > best.index) {
        return {
          match,
          index
        };
      }
      return best;
    }, {
      match: null,
      index: -1
    });

    // find the country match that is closest to the end of the string
    const bestCountryMatch = countryMatches.reduce((best, match) => {
      const index = getLastIndexOfRegex(address, match.countryRegex);
      if (index > best.index) {
        return {
          match,
          index
        };
      }
      return best;
    }, {
      match: null,
      index: -1
    });

    // return the best match, or undefined if no matches were found
    return {
      state: bestStateMatch.match?.state,
      country: bestCountryMatch.match?.country || bestStateMatch.match?.country
    };
  }
  function getLastIndexOfRegex(str, regex) {
    let match,
      lastIndex = -1;
    while ((match = regex.exec(str)) !== null) {
      // eslint-disable-line no-cond-assign
      lastIndex = match.index;
    }
    return lastIndex;
  }

  // pre populate country and state from location address if possible
  useEffect(() => {
    const newAddress = {
      ...newAcct?.address,
      ...getCountryAndStateFromAddress(location?.data?.data?.streetAddress)
    };
    onChange({
      data: 'newAcct',
      value: {
        ...newAcct,
        address: newAddress
      }
    });
  }, []);
  const onChangeExAcctEmail = async event => {
    setError(null);
    let {
      value
    } = event;
    value = value?.trim() || value;
    setLoading(true);
    GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      try {
        const user = await api.project(api.options.projectId).accounts().list({
          username: value
        });
        if (user?.items?.length !== 1) {
          throw new Error('user not found');
        }
        const existingUser = user?.items?.[0];
        const customerInfo = await RecovrSales.getCustomerInfo({
          email: existingUser.email
        });
        onChange([event, {
          data: 'exAcct',
          value: {
            ...customerInfo,
            ...existingUser,
            address: customerInfo?.addressFields
          }
        }]);
      } catch (err) {
        // error the form
        setError(err);
        onChange({
          data: 'exAcct',
          value: null
        });
      }
      setLoading(false);
    });
  };
  let icon = /*#__PURE__*/_jsx("img", {
    className: classnames(S.icon),
    src: "https://recovr-ui-assets.storage.googleapis.com/user.png",
    alt: "user icon"
  });
  if (loading) {
    icon = /*#__PURE__*/_jsx(PuffLoader, {
      size: 24
    });
  } else if (error) {
    icon = /*#__PURE__*/_jsx("img", {
      className: classnames(S.icon),
      src: "https://recovr-ui-assets.storage.googleapis.com/system-fail-icon.svg",
      alt: "user icon"
    });
  } else if (exAcct?.email) {
    icon = /*#__PURE__*/_jsx("img", {
      className: classnames(S.icon),
      src: "https://recovr-ui-assets.storage.googleapis.com/system-success-icon.svg",
      alt: "user icon"
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: S.container,
    children: [/*#__PURE__*/_jsx(Text, {
      variant: "bodyBold",
      children: "Customer Account Creation"
    }), /*#__PURE__*/_jsx(Text, {
      variant: "bodySmall",
      children: "Does this customer already have an account?"
    }), /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:rowM",
      className: S.buttonsContainer,
      children: [/*#__PURE__*/_jsx(ToggleButton, {
        variant: "salesFlowNewCustomer",
        onChange: onChangeNewAcct,
        value: isNewCustomer,
        eventData: true,
        children: "No"
      }), /*#__PURE__*/_jsx(ToggleButton, {
        variant: "salesFlowNewCustomer",
        "data-cy": Config.get('cypress', ['button', 'sales.existingUser'], 'button.sales.existingUser'),
        onChange: onChangeNewAcct,
        value: !isNewCustomer,
        eventData: false,
        children: "Yes"
      })]
    }), isNewCustomer ? /*#__PURE__*/_jsx("div", {
      className: S.newCustomerContainer,
      children: /*#__PURE__*/_jsx(UserForm, {
        onChange: onChangeUserForm,
        data: newAcct,
        errors: newAcctErrors,
        isExAcct: false
      })
    }) : /*#__PURE__*/_jsxs(Flex, {
      variant: "colM",
      className: S.existingCustomerContainer,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "body",
        children: "Enter the account email of the customer\u2019s RecovR account below to add this vehicle and device to their account."
      }), /*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colS",
        children: [/*#__PURE__*/_jsx(Label, {
          variant: "inputTitle",
          children: "Account Email"
        }), /*#__PURE__*/_jsx(CompositeTextInput, {
          variant: "salesFlowCustomerLookup",
          pre: icon,
          "data-cy": Config.get('cypress', ['input', 'sales.existingUser'], 'input.sales.existingUser'),
          eventData: "exAcctEmail",
          onChange: onChangeExAcctEmail,
          value: exAcctEmail
        }), /*#__PURE__*/_jsx(UserForm, {
          onChange: onChangeExAcct,
          data: exAcct,
          errors: exAcctErrors,
          isExAcct: true
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputCaption",
          children: error ? 'Email is not linked to an existing account' : null
        })]
      })]
    })]
  });
}

/**
 <Geocoder 
          {...rest}
          {...validator.dataProps( name )} 
          name={name}
          eventData={name} 
          onChange={this.onChange} 
          value={validator.value( name )}
          disabled={loading === true || disabled === true} />
 */